import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
export const REGISTER_URL = `${API_URL}/v1/ekyc/account/create`

const register = async (data: any) => {
  const response = await axios.post(REGISTER_URL, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}

export default register
